import { ReactNode } from "react";
import ChartDateRangeFilter from "./ChartDateRangeFilter";
import StatsBarChart, { StatsBarChartDatum } from "./StatsBarChart";

interface StatsChartPanelProps {
  title: string;
  subtitle?: string;
  fromDate: string;
  untilDate: string;
  onRangeChange: (fromDate: string, untilDate: string) => void;
  onApplyFilter: () => void;
  chartData: StatsBarChartDatum[];
  chartLoading?: boolean;
  filterLoading?: boolean;
  emptyText?: string;
  barColor?: string;
  headerExtra?: ReactNode;
}

export default function StatsChartPanel({
  title,
  subtitle,
  fromDate,
  untilDate,
  onRangeChange,
  onApplyFilter,
  chartData,
  chartLoading = false,
  filterLoading = false,
  emptyText,
  barColor,
  headerExtra,
}: StatsChartPanelProps) {
  return (
    <section className="rounded-2xl border border-gray-100 bg-white p-5 card-shadow">
      <div className="mb-6 flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
        <div className="text-right">
          <h2 className="text-lg font-bold text-gray-900">{title}</h2>
          {subtitle ? (
            <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
          ) : null}
          {headerExtra}
        </div>

        <ChartDateRangeFilter
          fromDate={fromDate}
          untilDate={untilDate}
          onRangeChange={onRangeChange}
          onApply={onApplyFilter}
          loading={filterLoading}
        />
      </div>

      <StatsBarChart
        data={chartData}
        loading={chartLoading}
        emptyText={emptyText}
        barColor={barColor}
      />
    </section>
  );
}
